import React, { useMemo } from "react";

const formatValue = (value) =>
  value !== undefined && value !== null && value !== "" ? value : "—";

const FailedRecordsStep = ({ uploadStatusData, uploadType }) => {
  const failedRecords = uploadStatusData?.detail || [];

  const columnConfig = useMemo(() => {
    switch (uploadType) {
      case "eventCreate":
        return [
          { key: "event_name", label: "Event Name" },
          { key: "date", label: "Date" },
          { key: "start_time", label: "Start Time" },
          { key: "end_time", label: "End Time" },
          { key: "event_level", label: "Event Level" },
          { key: "event_round", label: "Event Round" },
          { key: "failure_reason", label: "Failure Reason", isError: true },
        ];
      case "eventReschedule":
        return [
          { key: "event_name", label: "Event Name" },
          {
            key: "current_start_date_time",
            label: "Current Start Date Time",
          },
          {
            key: "current_end_date_time",
            label: "Current End Date Time",
          },
          {
            key: "reschedule_start_date_time",
            label: "Reschedule Start Date Time",
          },
          {
            key: "reschedule_end_date_time",
            label: "Reschedule End Date Time",
          },
          { key: "level", label: "Level" },
          { key: "round", label: "Round" },
          { key: "failure_reason", label: "Failure Reason", isError: true },
        ];
      case "eventDelete":
        return [
          { key: "start_date", label: "Start Date" },
          { key: "end_date", label: "End Date" },
          { key: "level", label: "Level" },
          { key: "round", label: "Round" },
          { key: "failure_reason", label: "Failure Reason", isError: true },
        ];
      case "uploadOfflineResponses":
        return [
          { key: "first_name", label: "First Name" },
          { key: "last_name", label: "Last Name" },
          { key: "isd_code", label: "ISD Code" },
          { key: "phone", label: "Phone" },
          { key: "grade", label: "Grade" },
          { key: "school_id", label: "School ID" },
          { key: "login_id", label: "Login ID" },
          { key: "event_name", label: "Event Name" },
          { key: "level", label: "Level" },
          { key: "round", label: "Round" },
          { key: "exam_name", label: "Exam Name" },
          { key: "failure_reason", label: "Failure Reason", isError: true },
        ];
      case "globalStudentsRegister":
        return [
          { key: "isd_code", label: "ISD Code" },
          { key: "phone", label: "Phone" },
          { key: "admission_id", label: "Admission ID" },
          { key: "failure_reason", label: "Failure Reason", isError: true },
        ];
      case "studentRegister":
      default:
        return [
          { key: "isd_code", label: "ISD Code" },
          { key: "phone", label: "Phone" },
          { key: "failure_reason", label: "Failure Reason", isError: true },
        ];
    }
  }, [uploadType]);

  const formatKey = (key) =>
    key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <section className="editcontianer" aria-live="polite">
      <h2>Failed Records</h2>

      {failedRecords.length === 0 ? (
        <p className="validation-step__status">
          We didn’t find any failed records for this upload.
        </p>
      ) : (
        <>
          <div className="editstep-table-wrapper" role="region">
            <table>
              <thead>
                <tr>
                  {columnConfig.map((column) => (
                    <th key={column.key}>{column.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {failedRecords.map((record, index) => (
                  <tr className="trcontainer" key={index}>
                    {columnConfig.map((column) => (
                      <td
                        key={column.key}
                        className={column.isError ? "error-messages" : ""}
                      >
                        {formatValue(record[column.key])}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="editstep-card-list">
            {failedRecords.map((record, index) => (
              <article className="editstep-card" key={`failed-${index}`}>
                <header className="editstep-card__header">
                  <span className="editstep-card__row-label">
                    Row {index + 1}
                  </span>
                </header>
                <dl className="editstep-card__details">
                  {columnConfig.map((column) => (
                    <div className="editstep-card__detail" key={column.key}>
                      <dt>{column.label || formatKey(column.key)}</dt>
                      <dd
                        className={column.isError ? "error-messages" : ""}
                        aria-label={column.label}
                      >
                        {formatValue(record[column.key])}
                      </dd>
                    </div>
                  ))}
                </dl>
              </article>
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default FailedRecordsStep;
